export class RenewalBuildData{
    module = {
		name: "Detail",
		new_name: "details",
		has_dot_menu: true,
		icon: 'fa-street-view',
		permission: 'details'
	}
    
}